import React from 'react'
import { useForm, FormProvider, SubmitHandler } from 'react-hook-form'
import { TextField } from '../../components/Forms/TextField'
import { Button } from '../../components/Button/Button'
import { CodeBlockField } from 'presentation/components/Forms/CodeBlockField'
import { useUsername } from 'presentation/hooks/useUsername'
import { Campaign } from 'domain/entities/Campaign'

export type FormValues = {
  id?: string
  title: string
}

type InventoryFormProps = {
  onSubmit: SubmitHandler<FormValues>
  onCancel: () => void
  initialData?: FormValues | null
  connectedCampaignList?: Campaign[]
  availableCampaignList?: Campaign[]
}

export const InventoryForm: React.FC<InventoryFormProps> = ({
  onSubmit,
  onCancel,
  initialData,
}) => {
  const methods = useForm<FormValues>({
    mode: 'onChange',
    defaultValues: {
      title: initialData?.title || '',
    },
  })

  const username = useUsername()

  const {
    handleSubmit,
    formState: { isValid },
  } = methods

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextField
          name="title"
          label="Inventory name"
          validation={{ required: 'The inventory name is required' }}
          required={true}
        />
        {initialData?.id && (
          <CodeBlockField
            name="apiUrl"
            label="API Integration URL"
            description="API integration URL for your inventory. More information on how to use this URL can be found in our [documentation](https://tv.adshines.io/docs)"
            message={`https://tv.adshines.io/api/getAd?inventoryId=${initialData.id}&username=${username}&multiplier=<multiplier>`}
          />
        )}
        <div className="form-actions">
          <Button variant="cancel" onClick={onCancel} type="button">
            Cancel
          </Button>
          <Button variant="primary" disabled={!isValid} type="submit">
            Save
          </Button>
        </div>
      </form>
    </FormProvider>
  )
}
